<script>
import { BImg } from "bootstrap-vue";

export default {
  extends: BImg
};
</script>